<div class="container-fluid bg-white p-0 test-report" *ngIf="!isLoading">
  <ng-container *ngIf="(dashboardConfig$ | async) as groups">
    <nz-tabset
      [nzSelectedIndex]="activeGroupIndex"
      (nzSelectedIndexChange)="activeGroupIndex = $event"
      class="trs-tab-set">
      <nz-tab *ngFor="let group of groups" [nzTitle]="getGroupTitle(group)">
        <div class="row card-container pt-2">
          <app-metric-card-view
            *ngFor="let metric of group.metrics"
            [metric]="metric"
            [ngClass]="getTileClass(metric.size)"
          ></app-metric-card-view>
        </div>
      </nz-tab>
    </nz-tabset>
  </ng-container>
</div>

<!-- Skeleton placeholder shown while data is loading -->
<div class="container-fluid bg-white p-0 test-report trs-skeleton" *ngIf="isLoading">
  <!-- Fake tab bar -->
  <div class="trs-skeleton-tabs">
    <div class="trs-skeleton-tab active"></div>
    <div class="trs-skeleton-tab"></div>
    <div class="trs-skeleton-tab"></div>
    <div class="trs-skeleton-tab"></div>
  </div>

  <!-- Fake cards row -->
  <div class="trs-skeleton-cards">
    <div class="trs-skeleton-card col-md-3" *ngFor="let i of [1,2,3,4]">
      <nz-skeleton [nzActive]="true" [nzAvatar]="{ shape: 'circle', size: 'default' }" [nzParagraph]="{ rows: 2 }"></nz-skeleton>
    </div>
  </div>

  <!-- Fake wide card / chart row -->
  <div class="trs-skeleton-cards">
    <div class="trs-skeleton-card col-md-6">
      <nz-skeleton [nzActive]="true" [nzAvatar]="false" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
    </div>
    <div class="trs-skeleton-card col-md-6">
      <nz-skeleton [nzActive]="true" [nzAvatar]="false" [nzParagraph]="{ rows: 4 }"></nz-skeleton>
    </div>
  </div>

  <!-- Fake table header -->
  <div class="trs-skeleton-cards">
    <div class="trs-skeleton-card col-md-12">
      <nz-skeleton [nzActive]="true" [nzAvatar]="false" [nzParagraph]="{ rows: 5 }"></nz-skeleton>
    </div>
  </div>
</div>
